import { secondsToTicks, type Cue, type TrackStyle } from '@prism/contracts';
import { useVideoContentRect } from './videoContentRect';
import { CueOverlay } from '../subtitles/CueOverlay';

/**
 * The cues at the playhead over the picture (1.9.0): every active cue in its cell, with the track's and the cue's
 * style, laid out as the export burn-in does (contracts cueLayout, cueRuns).
 */
export function SubtitleOverlay({ track, seconds, video }: { track: { cues: Cue[]; style?: TrackStyle | null } | null; seconds: number; video: HTMLVideoElement | null }) {
  const rect = useVideoContentRect(video);
  if (!track) return null;
  return <CueOverlay cues={track.cues} trackStyle={track.style} ticks={secondsToTicks(seconds)} rect={rect} />;
}
